var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m542.16 226.2c-105.89-114.93-278.43-114.93-384.32 0l-35 37.988c-8.2305 8.9375-8.2305 22.688 0 31.625l35 37.988c105.89 114.93 278.43 114.93 384.32 0l35-37.988c8.2305-8.9375 8.2305-22.688 0-31.625zm-192.16-62.867c-64.434 0-116.67 52.234-116.67 116.67s52.234 116.67 116.67 116.67 116.67-52.234 116.67-116.67-52.234-116.67-116.67-116.67zm0 163.34c25.773 0 46.668-20.895 46.668-46.668s-20.895-46.668-46.668-46.668-46.668 20.895-46.668 46.668 20.895 46.668 46.668 46.668z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.79c64b59b45d81f36338fbc86cf9c962.svg";
export { ForwardRef as ReactComponent };